import { Typography, Grid, Link } from '@material-ui/core';

export function SbomPowerBI() {
  return (
    <Grid container style={{ maxWidth: '100%' }}>
      <Typography variant="body1" gutterBottom>
        If you're unable to view the PowerBI data, first{' '}
        <Link
          target="_blank"
          href="https://app.powerbi.com/home?experience=power-bi"
        >
          sign in to PowerBI
        </Link>
        , then refresh and try again. You can also open this embedded dashboard
        in the{' '}
        <Link
          target="_blank"
          href="https://app.powerbi.com/groups/me/reports/5fc581ce-86c8-4d54-ae62-606a45fe89c9/53c202410c8d66d61278?ctid=3bea478c-1684-4a8c-8e85-045ec54ba430&experience=power-bi"
        >
          PowerBI web app
        </Link>
        .
      </Typography>
      <iframe
        style={{
          height: '90vh',
          width: '100vw',
          border: 0,
        }}
        title="GitHub Repo Dependencies - SBOM"
        src="https://app.powerbi.com/reportEmbed?reportId=5fc581ce-86c8-4d54-ae62-606a45fe89c9&autoAuth=true&ctid=3bea478c-1684-4a8c-8e85-045ec54ba430"
        allowFullScreen
      />
    </Grid>
  );
}
